import React, { createContext, useContext, useMemo } from "react";
import { PlanMetadataService, type PlanMetadataSettings } from "../features/admin/services/PlanMetadataService";

const PlanMetadataServiceContext = createContext<PlanMetadataService | null>(null);

export const PlanMetadataServiceProvider: React.FC<{ settings: PlanMetadataSettings; children: React.ReactNode }> = ({ settings, children }) => {
    const service = useMemo(() => {
        const s = new PlanMetadataService();
        s.configure(settings);
        return s;
    }, [settings]);

    return (
        <PlanMetadataServiceContext.Provider value={service}>
            {children}
        </PlanMetadataServiceContext.Provider>
    );
};

export const usePlanMetadataService = () => {
    const ctx = useContext(PlanMetadataServiceContext);
    if (!ctx) throw new Error("usePlanMetadataService must be used within a PlanMetadataServiceProvider");
    return ctx;
};
